export default __webpack_public_path__ + "static/media/Frame758532303.fa354957.svg";